
<div class="" style="margin-left: 75px;" v-resize="onResize">
    <!-- site dialog -->
    <d-site
        v-model  = "unit.show"
        :site-id = "unit.id"
        :edit    = "unit.edit"
        @saved   = "onUnitSaved"
        @type    = "onUnitType"
    />
    <!-- site dialog -->

    <d-inspection-assign-unit
        v-model     = "showAssign"
        :inspection = "order.inspection"
        @assigned   = "onAssigned"
    />

    <p-inspection-report
        v-model= "showReport"
        :order = "order.selected"
    />

    <c-app-bar
        :title         = "$t('disposition.title')"
        :categories    = "[]"
        :enable-search = "false"
        @home          = "onHome"
    >
        <template v-slot:search>
            <div
                v-if  = "isDisponent || isDispatcher"
                class = "ml-4 mr-1"
                style = "margin-top: 0;"
            >
                <f-dispatcher-select
                    v-model   = "user"
                    :dense    = "true"
                    :outlined = "true"
                />
            </div>

            <div
                v-if="isRestrictedDispatcher && !isDisponent && !isDispatcher"
                class = "primary--text lm-border disposition-user"
            >
                {{ currentUser }}
            </div>

            <div class="v-flex" style="margin-top: -3px">
                <c-toolbar-button
                    icon     = "mdi-home"
                    color    = "primary"
                    :size    = "22"
                    :tooltip = "$t('home.button')"
                    class    = "ml-2"
                    @click   = "onHome"
                />
            </div>

            <div class="ml-2" v-if="isDisponent || isDisponent || isRestrictedDispatcher">
                <p-disposition-buttons
                    :user       = "user"
                    @assign     = "onAssignOn"
                    @dispatch   = "onDispatchOn"
                    @all-orders = "onAllOrdersOn"
                    @map        = "onMapOn"
                    ref         = "dispositionButtons"
                />
            </div>

            <div class="ml-3 mt-1" v-if="order.selected.id">
                <c-fab-menu
                    icon     = "mdi-history"
                    :menu    = "user ? download.menu.technician : download.menu.order"
                    @entry   = "onDownload"
                />
            </div>

            <div class="ml-3 mt-1" v-if="user && !order.selected.id">
                <c-fab-menu
                    icon     = "mdi-history"
                    :menu    = "download.menu.technician"
                    @entry   = "onDownload"
                />
            </div>

            <v-spacer />
        </template>
    </c-app-bar>

    <div style="margin-right: 70px">
        <v-row class="no-frame top-line">
            <v-col class="no-frame order-col col-3"  v-show="!modes.allOrders">
                <p-order-card-iterator
                    class     = "mt-1"
                    @selected = "onSelected"
                />
            </v-col>

            <v-col class="no-frame order-col col-6 pt-1" v-show="modes.allOrders">
                <p-disposition-location-card-iterator
                    class         = "w-100"
                    :title        = "inspectionTitle"
                    :data         = "allOrders.data"
                    :user         = "user"
                    :selected     = "unit.selected"
                    :assign-on    = "modes.assign"
                    :dispatch-on  = "modes.dispatch"
                    :all          = "true"
                    @site         = "onUnit"
                    @selected     = "onUnitSelected"
                    @new-site     = "onNewUnit"
                    @refresh      = "onRefreshInspections"
                    @filtered     = "onUnitsFiltered"
                    @locate       = "onLocate"
                    ref           = "allUnitIterator"
                />
            </v-col>

            <v-col class="no-frame unit-col  col-3 pl-3 pt-1" v-show="!modes.allOrders">
                <p-disposition-location-card-iterator
                    class         = "w-100"
                    :title        = "inspectionTitle"
                    :order        = "order.selected"
                    :data         = "order.data"
                    :user         = "user"
                    :loading      = "order.loading"
                    :selected     = "unit.selected"
                    :assign-on    = "modes.assign"
                    :dispatch-on  = "modes.dispatch"
                    :all          = "false"
                    @site         = "onUnit"
                    @selected     = "onUnitSelected"
                    @new-site     = "onNewUnit"
                    @refresh      = "onRefreshInspections"
                    @filtered     = "onUnitsFiltered"
                    @locate       = "onLocate"
                    ref           = "unitIterator"
                />
            </v-col>

            <v-col class="no-frame col-6 pa-3 pr-0" style="position: relative">
                <!-- map -->
                <div
                    v-if="modes.map"
                    class="disposition-map"
                >
                    <c-inspection-map
                        :order        = "order.selected"
                        :technician   = "user"
                        :assignments  = "modes.allOrders ? assignments : order.data.assignments"
                        :filteredSites = "filteredSites"
                        @selected = "onMapSelected"
                        ref       = "map"
                    />
                </div>
                <!-- map -->

                <c-column-header
                    :label = "$t('disposition.order.unit.title') + ' ' + location"
                    class  = "primary text--white"
                >
                    <template v-slot:pre>
                        <div style="margin-top: -2px; margin-right: 8px;">
                            <c-inspection-menu
                                :inspection = "inspection"
                                @menu       = "onMenu"
                            />
                        </div>
                    </template>

                    <template v-slot:post>
                        <p-inspection-messages
                            v-if="inspection && inspection.messages && inspection.messages.length > 0"
                            :messages = "inspection.messages"
                        />
                    </template>

                    <template v-slot:toolbar>
                        <div
                            class = "mr-1 v-flex"
                            style = "margin-top: -2px"
                        >
                            <c-toolbar-button
                                v-if     = "isDone"
                                color    = "white"
                                size     = "22"
                                icon     = "mdi-lock-open"
                                :tooltip = "$t('disposition.inspection.reopen.tooltip')"
                                @click   = "onReopen"
                                class    = "mr-1"
                            />

                            <c-toolbar-button
                                v-if     = "isNewUnit"
                                color    = "white"
                                size     = "24"
                                icon     = "mdi-elevator-passenger"
                                :tooltip = "$t('disposition.inspection.tooltip.assign')"
                                @click   = "onAssign"
                                class    = "mr-1"
                            />

                            <c-toolbar-button
                                v-if     = "isNewUnit"
                                color    = "white"
                                size     = "24"
                                icon     = "mdi-plus"
                                :tooltip = "$t('disposition.inspection.tooltip.create')"
                                @click   = "onCreate"
                            />

                            <c-toolbar-button
                                v-if     = "order.inspection"
                                color    = "white"
                                size     = "20"
                                icon     = "mdi-refresh"
                                :tooltip = "$t('disposition.unit.refresh')"
                                @click   = "onRefresh"
                            />
                        </div>
                    </template>
                </c-column-header>

                <!-- device type conflict of the app (HCIT-943) -->
                <p-inspection-device-type-conflict
                    v-if        = "order.inspection"
                    :inspection = "order.inspection"
                    :checking   = "deviceTypeChecking"
                    @unit       = "onUnit"
                    @check      = "onCheckDeviceType"
                />

                <c-inspection
                    v-if        = "order.inspection"
                    :inspection = "order.inspection"
                    :height     = "height"
                    :area       = "area"
                    ref         = "disposition"
                    @refresh    = "onRefresh"
                    @technician = "onTechnician"
                    @saved      = "onInspectionSaved"
                    @menu       = "onMenu"
                />
            </v-col>
        </v-row>
    </div>
</div>
